import { XMarkIcon } from '@heroicons/react/24/outline'
import { NON_PAYMENT_POLICY_URL, TERMS_URL } from '@/lib/policyConsent'

const NOTICE_KEY = 'metrly:notice:backup-vault-2026-09-14'
const NOTICE_EXPIRES_AT = Date.parse('2026-10-14T00:00:00Z')

export function isBillingPolicyNoticeVisible() {
  if (Date.now() >= NOTICE_EXPIRES_AT) return false
  try { return localStorage.getItem(NOTICE_KEY) !== 'dismissed' } catch { return true }
}

interface BillingPolicyChangeBannerProps {
  onDismiss: () => void
}

export default function BillingPolicyChangeBanner({ onDismiss }: BillingPolicyChangeBannerProps) {
  const dismiss = () => {
    try { localStorage.setItem(NOTICE_KEY, 'dismissed') } catch { /* storage is optional */ }
    onDismiss()
  }

  return (
    <div className="fixed inset-x-0 top-0 z-[60] h-9 border-b border-gray-200 bg-white/95 text-gray-700 backdrop-blur dark:border-[#2d2d2d] dark:bg-[#181818]/95 dark:text-gray-300" role="status">
      <div className="relative flex h-full items-center justify-center px-10 text-xs">
        <p className="min-w-0 truncate text-center">
          <span className="font-semibold text-gray-900 dark:text-gray-100">Billing and service terms update.</span>{' '}
          <span className="hidden lg:inline">Review the terms shown for your service, including its backup allowance and recovery window. </span>
          <a href="https://metrly.com/updates/billing-policy-2026-09-01" target="_blank" rel="noreferrer" className="font-medium underline underline-offset-2">Review changes</a>
          <span className="hidden sm:inline"> · <a href={TERMS_URL} target="_blank" rel="noreferrer" className="underline underline-offset-2">Terms</a> · <a href={NON_PAYMENT_POLICY_URL} target="_blank" rel="noreferrer" className="underline underline-offset-2">Non-Payment Policy</a></span>
        </p>
        <button type="button" onClick={dismiss} aria-label="Dismiss billing policy notice" className="absolute right-2 rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:hover:bg-white/10 dark:hover:text-white">
          <XMarkIcon className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  )
}
